<template>
  <v-row class="ftc" align-content="center" justify="start">
    <v-col>
      <v-dialog
        v-model="dialog"
        persistent
        width="1024"
        @click:outside="dialog = false"
      >
        <template #activator="{ props }">
          <v-btn
            color="green"
            size="x-small"
            variant="plain"
            append-icon="mdi-plus"
            v-bind="props"
            >Adicionar Nova Dependência</v-btn
          >
        </template>

        <v-card>
          <v-card-title>
            <div class="d-flex justify-space-between">
              <span class="text-h5">Criar Dependência</span>
              <v-btn
                variant="plain"
                rounded="xl"
                prepend-icon="mdi-window-close"
                @click="dialog = false"
              ></v-btn>
            </div>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-form ref="form" validate-on="lazy submit">
                <v-row>
                  <v-col cols="4" sm="6">
                    <v-select
                      v-model="this.tipoDepSelecionado"
                      label="Tipo de Dependência*"
                      :items="tiposDependencia"
                      :rules="tipoDepSelecionadoRules"
                    ></v-select>
                  </v-col>
                  <v-col cols="4" sm="6">
                    <v-select
                      v-model="this.csuSelecionado"
                      label="Casos de Uso*"
                      :items="selectOpcoes.map((item) => item.nome)"
                      :rules="csuSelecionadoRules"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>

            <small>*Campo obrigatório</small>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="blue-darken-1"
              variant="text"
              @click="submitDependencia()"
            >
              Salvar
              <v-progress-circular
                v-if="this.isLoading"
                class="ml-2"
                indeterminate
                size="20"
              />
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import axios from 'axios';

import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  emits: ['dependenciaCriada'],
  props: {
    dependencias: {
      default: [],
    },
  },
  data: () => ({
    dialog: false,
    csuSelecionado: '',
    eferenteSelecionado: '',
    selectOpcoes: [],
    tipoDepSelecionado: '',
    tiposDependencia: ['EXTEND', 'INCLUDE', 'SPECIALIZATION'],
    isLoading: false,
    csuSelecionadoRules: [(v) => !!v || 'Caso de uso é obrigatório'],
    eferenteSelecionadoRules: [
      (v) => !!v || 'Caso de uso eferente é obrigatório',
    ],
    tipoDepSelecionadoRules: [
      (v) => !!v || 'Tipo da dependência é obrigatória',
    ],
  }),
  created() {
    axios
      .get(apiUrl + '/api/v1/productBacklog', {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      })
      .then((res) => {
        // {id e idProjeto} = this.$route.params

        this.selectOpcoes = res.data.useCases.filter((item) =>
          this.checkConstraintDep(item),
        );

        // console.log(
        //   res.data.useCases.filter(
        //     (item) =>
        //       item.id_projeto.toString() ===
        //         this.$route.params.idProjeto.toString() &&
        //       item.id_caso_de_uso !== this.$route.params.id &&
        //       item.ativo === true &&
        //       item.status !== 'EM_EDICAO'
        //   )
        // );
      })
      .catch((error) => console.log(error));
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    async submitDependencia() {
      const isValid = (await this.$refs.form.validate()).valid;
      this.isLoading = true;

      if (isValid) {
        const csuId = this.$route.params.id;
        const eferenteId = this.selectOpcoes.filter(
          (item) => item.nome == this.csuSelecionado,
        )[0].id_caso_de_uso;

        axios
          .post(
            apiUrl + '/api/v1/productBacklog/dependencia',
            {
              // eslint-disable-next-line camelcase
              id_caso_de_uso: csuId,
              // eslint-disable-next-line camelcase
              id_dependencia_eferente: eferenteId,
              // eslint-disable-next-line camelcase
              tipo_dependencia: this.tipoDepSelecionado,
            },
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          )
          .then(() => {
            this.$emit('dependenciaCriada');

            this.dialog = false;
            this.csuSelecionado = '';
            this.tipoDepSelecionado = '';
            this.selectOpcoes = this.selectOpcoes.filter((item) =>
              this.checkConstraintDep(item),
            );
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Erro encontrado ao criar dependencia');
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },

    checkConstraintDep(item) {
      // verifica se foi excluido ou é rascunho
      if (item.ativo !== true || item.status === 'EM_EDICAO') {
        return false;
      }

      // verifica se pertence ao projeto
      if (
        item.id_projeto.toString() !== this.$route.params.idProjeto.toString()
      ) {
        return false;
      }
      // verifica se não é o mesmo csu
      if (item.id_caso_de_uso === this.$route.params.id) {
        return false;
      }
      // if (item.ativo === true && item.status !== 'EM_EDICAO') {
      //   // verifica se pertence ao projeto e se não é o mesmo caso de uso
      //   if (
      //     item.id_projeto.toString() ===
      //       this.$route.params.idProjeto.toString() &&
      //     item.id_caso_de_uso !== this.$route.params.id
      //   ) {
      //     return true;
      //   }
      // }

      const id =
        item.id_caso_de_uso !== this.$route.params.id
          ? item.id_caso_de_uso
          : item.id_dependencia_eferente;
      // // console.log(id);

      // Verifica se já foi adicionado como dependencia
      const alreadyExist =
        this.dependencias.filter((dep) => {
          // verifica se já existe a relação id_dep(any) id_csu(aberto)
          if (
            id.toString() === dep.id_caso_de_uso &&
            this.$route.params.id.toString() === dep.id_dependencia_eferente
          ) {
            return true;
          }
          // verifica se já existe a relação id_csu(aberto) id_dep(any)
          if (
            id.toString() === dep.id_dependencia_eferente &&
            this.$route.params.id.toString() === dep.id_caso_de_uso
          ) {
            return true;
          }

          return false;
        }).length >= 1;
      if (alreadyExist) {
        return false;
      }

      return true;
    },
  },
};
</script>
<style scoped>
.ftc {
  width: fit-content;
}
</style>
